import { postMethodWithTokenUpload } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_LEAD_CAPTURE = 'CREATE_LEAD_CAPTURE';
export const CREATE_LEAD_CAPTURE_SUCCESS = 'CREATE_LEAD_CAPTURE_SUCCESS';
export const CREATE_LEAD_CAPTURE_FAILURE = 'CREATE_LEAD_CAPTURE_FAILURE';

// Action Creators
export const createLeadCapture = () => ({
  type: CREATE_LEAD_CAPTURE,
});

export const createLeadCaptureSuccess = (data) => ({
  type: CREATE_LEAD_CAPTURE_SUCCESS,
  payload: data,
});

export const createLeadCaptureFailure = (error) => ({
  type: CREATE_LEAD_CAPTURE_FAILURE,
  payload: error,
});

// Thunk Function
export const createLeadCaptureCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(createLeadCapture());
    try {
      const response = await postMethodWithTokenUpload(url.leadCapture, data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createLeadCaptureSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(createLeadCaptureFailure(response?.data));
      }
    } catch (error) {
      dispatch(createLeadCaptureFailure(error?.message));
    }
  };
};
